import React from 'react'
import User from '../../components/user/User'
import Video from '../../components/video/Video'
import Warning from '../../components/warning/Warning'
import './aside.css'

const Aside = () => {

      return (
            <div className="aside">
                  <User /> 
                  <Video />
                  <Warning />
            </div>
      )
}

export default Aside
